// First-party analytics tracker (public site only). Session-scoped, first-touch attribution.
const API = process.env.REACT_APP_BACKEND_URL;
const SID_KEY = "hr_sid";
const ATTR_KEY = "hr_attr";

export function getSessionId() {
  let sid = sessionStorage.getItem(SID_KEY);
  if (!sid) {
    sid = (crypto.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    sessionStorage.setItem(SID_KEY, sid);
  }
  return sid;
}

export function getAttribution() {
  let raw = sessionStorage.getItem(ATTR_KEY);
  if (!raw) {
    const p = new URL(window.location.href).searchParams;
    raw = JSON.stringify({
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      utm_content: p.get("utm_content") || "",
      utm_term: p.get("utm_term") || "",
      gclid: p.get("gclid") || "",
      fbclid: p.get("fbclid") || "",
      referrer: document.referrer || "",
    });
    sessionStorage.setItem(ATTR_KEY, raw);
  }
  try { return JSON.parse(raw); } catch { return {}; }
}

export function track(type, extra = {}) {
  try {
    if (window.location.pathname.startsWith("/admin")) return;
    fetch(`${API}/api/public/analytics/track`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      keepalive: true,
      body: JSON.stringify({
        type,
        session_id: getSessionId(),
        path: window.location.pathname,
        title: document.title,
        ...getAttribution(),
        ...extra,
      }),
    }).catch(() => {});
  } catch { /* analytics must never break the site */ }
}
